import React, { useState } from 'react';
import {
  Container,
  FormControl,
  Input,
  FormLabel,
  Text,
  Button,
} from '@chakra-ui/react';
import { firestore } from '../firebase';

export const AddTimes = () => {
  const [updated, setUpdated] = useState(false);
  const [error, setError] = useState(false);
  const [phrase, setPhrase] = useState('');
  const [times, setTimes] = useState({
    fajr: '',
    dhuhr: '',
    asr: '',
    isha: '',
  });

  const handleChange = (e) => {
    const value = e.target.value;

    setTimes({
      ...times,
      [e.target.name]: value,
    });
  };

  const handleAdd = () => {
    var timesRef = firestore.collection('salaah').doc('timesObj');
    if (phrase !== 'ComputerScreen1!') {
      return;
    }
    return timesRef
      .update({
        asr: times.asr,
        dhuhr: times.dhuhr,
        fajr: times.fajr,
        isha: times.isha,
      })
      .then(() => {
        console.log('Document successfully updated!');
        setUpdated(true);
      })
      .catch((error) => {
        console.error('Error updating document: ', error);
        setError('Error Updating Times');
      });
  };

  const handlePhraseClick = (e) => {
    setPhrase(e.target.value);
  };

  return (
    <Container>
      <Text textAlign={'center'} fontWeight={'bold'} fontSize={'1.5rem'}>
        Add Jamaah Times
      </Text>
      <FormControl>
        <FormLabel htmlFor="email">Fajr Jamaah</FormLabel>
        <Input name="fajr" type="text" onChange={handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel htmlFor="email">Dhuhr Jamaah</FormLabel>
        <Input name="dhuhr" type="text" onChange={handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel htmlFor="email">Asr Jamaah</FormLabel>
        <Input name="asr" type="text" onChange={handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel htmlFor="email">Isha Jamaah</FormLabel>
        <Input name="isha" type="text" onChange={handleChange} />
      </FormControl>
      <FormLabel htmlFor="email">Phrase</FormLabel>
      <Input name="isha" type="password" onChange={handlePhraseClick} />
      <Button
        colorScheme="blue"
        mt={'1rem'}
        onClick={handleAdd}
        mb="1rem"
        disabled={phrase !== 'ComputerScreen1!'}
      >
        Add Times
      </Button>
      {updated && <Text>Times updated successfully</Text>}
      {error && <Text>Error updating times</Text>}
    </Container>
  );
};
